.sidebarNavigationV2 {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding-bottom: 0px !important;

  /* first menu */
  ul {
    height: 100%;
    padding-top: 24px;
  }

  /* menu groups */
  ul[role='group'] {
    padding-top: 0px;
  }

  /* Section labels */
  li[role='presentation'] {
    > div {
      padding-left: 16px;
      padding-top: 16px;
      padding-bottom: 0px;
    }
  }

  /* Section items */
  li:not([role='presentation']) {
    height: 34px;
    line-height: 34px;
    padding-left: 16px !important;
    margin: 0px;
  }
  li:not(:last-child) {
    margin-bottom: 0px !important;
  }

  /* Children */
  [class='ant-layout-sider-children'] {
    flex: 1;
    overflow: auto;
  }

  /* Trigger */
  [class='ant-layout-sider-trigger'] {
    position: relative;
    width: 100% !important;
    border-right: 1px solid var(--color-border);
  }
}
